import { Injectable } from "@angular/core";
import { createStore, withProps } from "@ngneat/elf";
import { localStorageStrategy, persistState } from "@ngneat/elf-persist-state";
import { debounceTime } from "rxjs";

export function createInitialState(): ChecklistState {
	return {
		preopeningChecklistSubmitted: null,
	};
}
const checklistStateStore = createStore({ name: "checklist-state" }, withProps<ChecklistState>(createInitialState()));

@Injectable({ providedIn: "root" })
export class ChecklistStateStore {
	constructor() {
		persistState(checklistStateStore, {
			storage: localStorageStrategy,
			source: () => checklistStateStore.pipe(debounceTime(1000)),
		});
	}

	public store = checklistStateStore;

	reset = () => {
		checklistStateStore.reset();
	};
}

export interface ChecklistState {
	preopeningChecklistSubmitted: { result: string; submitted: string };
}
